import { useNavigate } from "react-router-dom";

type CheckoutSideItemsTypes = {
  product_id: number;
  product_image: string;
  product_name: string;
  product_price: string;
  product_quantity: string;
};

const CheckoutSideItems = ({
  product_id,
  product_image,
  product_name,
  product_price,
  product_quantity,
}: CheckoutSideItemsTypes) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="single">
        <figure>
          <img
            style={{ cursor: "pointer" }}
            onClick={() => navigate(`/product-details/${product_id}`)}
            src={product_image} alt="Image" />
        </figure>
        <div className="info">
          <h4  style={{ cursor: "pointer" }} onClick={() => navigate(`/product-details/${product_id}`)}>{product_name}</h4>
          <p>
            Price: <strong>{product_price}</strong>
          </p>
          <p>
            QTY: <strong>{product_quantity}</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default CheckoutSideItems;
